import { PlaidAccountSubtypes, PlaidAccountTypes } from '@/types/plaid.types'

export function getCurrentBalanceType(type: string, subtype?: string) {
  return type === PlaidAccountTypes.Loan ||
    type === PlaidAccountTypes.Investment ||
    type === PlaidAccountTypes.Credit ||
    subtype === PlaidAccountSubtypes.CashManagement
    ? 'current'
    : 'available'
}
